import cartDrawer from "./cart-drawer.js";
import checkoutPage from "./checkout-page.js";
import productLoop from "./product-loop.js";
import singleProduct from "./single-product.js";
import singleProductModal from "./single-product-modal.js";
import filters from "./filters.js";
import tabs from "./tabs.js";
import stockAlert from "./woo-product-stock-alert.js";
import videoPanel from "./full-width-video-panel.js";
import blocks from "./blocks.js";
import loginModal from "./login-modal.js";
import menus from "./menu.js";
import emailSignup from "./emailSignup.js";
import pressArticles from "./press-articles.js";
import promotionalProductSLider from "./promotional-product-slider.js";
import reengagement from "./reengagement.js";

window.$ = jQuery;

const nalgeneFooter = (function($) {

  cartDrawer();
  checkoutPage();
  productLoop();
  filters();
  blocks();
  singleProduct.init();
  singleProductModal();
  tabs();
  stockAlert();
  videoPanel();
  menus();
  loginModal();
  emailSignup();
  pressArticles();
  promotionalProductSLider();
  reengagement();

  const $body = $( 'body' );
  const $preHeaderBanner = $( '.pre-header-banner' );  
  const $siteHeader = $( '.site-header' );
  const $footerNavToggle = $(".toggle-footer-nav");
  const breakPoint = 992;

  checkInitialSize();
  setHeaderPostionAndMargins();

  function checkInitialSize() {
    if (window.innerWidth > breakPoint) {
      footerNavRemoveBtn();
    } else {
      footerNavAddBtn();
    }
  }

  function setHeaderPostionAndMargins() {

    var combinedHeaderHeight = ( $preHeaderBanner.length > 0 ) ? $preHeaderBanner.outerHeight() + $siteHeader.outerHeight() : $siteHeader.outerHeight();

    $( 'body' ).css( { 
      marginTop: combinedHeaderHeight + 'px' 
    } ); 
    
    if( $preHeaderBanner.length > 0 ) {

      $siteHeader.css( { 
        top: $preHeaderBanner.outerHeight() + 'px' 
      } ); 
    
    }
  
  }

  window.addEventListener(
    "resize",
    function() {

      setHeaderPostionAndMargins();

      if (window.innerWidth > 992) {
        footerNavRemoveBtn();
      } else {
        footerNavAddBtn();
      }

    },
    false
  );

  $footerNavToggle.on("click", function(e) {
    if (window.innerWidth > breakPoint) {
      return;
    }

    let expanded = $(this).attr("aria-expanded");
    if (expanded === "false") {
      $(this).attr("aria-expanded", "true");
    } else {
      $(this).attr("aria-expanded", "false");
    }

    $(this).toggleClass("active");
    $(this)
      .siblings()
      .toggle();
  });

  function footerNavRemoveBtn() {
    $footerNavToggle.removeAttr("role");
    $footerNavToggle.removeAttr("aria-expanded");
  }

  function footerNavAddBtn() {
    $footerNavToggle.attr("role", "button");
    $footerNavToggle.attr("aria-expanded", "false");
  }

  $(window).scroll(function() {
    if ($(window).scrollTop() > 30) {
      $(".site-header").addClass("sticky");
    } else {
      $(".site-header").removeClass("sticky");
    }
  });

  $(".ginput_container input").on("focus", function(e) {
    if ($(this).attr("type") === "file") {
      return;
    }

    let label = $('label[for="' + $(this).attr("id") + '"]').addClass(
      "visible"
    );
  });

  $(".ginput_container input").on("blur", function(e) {
    let label = $('label[for="' + $(this).attr("id") + '"]').removeClass(
      "visible"
    );
  });
})(jQuery);
